export default __webpack_public_path__ + "static/media/ViperDesktop.7a9efcd9.png";